import axios from "axios";
import React, { useState, useEffect } from "react";
import { Link, useNavigate } from "react-router-dom";
import secureLocalStorage from "react-secure-storage";
import baseurl from "./Baseurl";
import { useCart } from "./CartContext";
import { ToastContainer } from "react-toastify";
import { FaShoppingCart } from "react-icons/fa";

const Shearchbar = () => {
  let Navigate = useNavigate();
  const { cartRefresh } = useCart();
  let [showprofile, setshowprofile] = useState([]);
  let _id = secureLocalStorage.getItem("n_id");
  let token = secureLocalStorage.getItem("n_token");
  let [show_cart_list, setshow_cart_list] = useState([]);
  let [logo, setLogo] = useState("");

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const payload = { user_id: _id };

        const res = await axios.post(
          `${process.env.REACT_APP_API}website/get_user_profile`,
          payload,
        );

        if (res?.data?.result) {
          setshowprofile(res.data.data);
        }
      } catch (error) {
        console.log(error);
      }
    };

    if (_id) fetchProfile();
  }, []);

  const fetchProduct = async () => {
    try {
      let items = { user_id: _id };

      const res = await axios.post(
        `${process.env.REACT_APP_API}website/cart_details`,
        items,
        { headers: { token } },
      );

      if (res?.data?.result) {
        setshow_cart_list(res.data.data);
      } else {
        setshow_cart_list([]);
      }
    } catch (error) {
      setshow_cart_list([]);
      console.log(error);
    }
  };

  const fetchLogo = async () => {
    try {
      const res = await axios.get(
        `${process.env.REACT_APP_API}website/logo_list`,
      );
      setLogo(res.data.data[0]);
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    if (_id) fetchProduct();
    fetchLogo();
  }, [cartRefresh]);

  return (
    <div>
      <ToastContainer position="top-center" />

      <div id="active-sticky2" className="header-space bg-white">
        <div className="container">
          <div className="row align-items-center">
            {/* LEFT SECTION */}
            <div className="col-6 col-sm-4 col-lg-7 col-xl-8">
              <div className="d-flex">
                <div className="flex-shrink-0">
                  <div className="d-flex align-items-center vertical-menu">
                    <a href="/" className="logo">
                      <img
                        src={`${process.env.REACT_APP_API}uploads/${logo?.logo_image}`}
                        alt="logo"
                        width={50}
                      />
                    </a>

                    <p
                      className="logo-description"
                    >
                      {logo?.description || "Gemstone Store"}
                    </p>
                  </div>
                </div>

                {/* DESKTOP SEARCH */}
                <div className="flex-grow-1 d-none d-lg-block">
                  <form
                    className="search-form position-relative"
                    onSubmit={(e) => e.preventDefault()}
                  >
                    <div className="input-group">
                      <input
                        className="form-control"
                        type="text"
                        placeholder="Enter your search key ... "
                        onClick={() => Navigate(`/search`)}
                        autoComplete="off"
                      />
                    </div>
                  </form>
                </div>
              </div>
            </div>

            {/* RIGHT SECTION */}
            <div className="col-6 col-sm-8 col-lg-5 col-xl-4">
              <ul className="quick-links">
                <li className="quick-link-item d-none d-sm-flex">
                  <Link to="/astrologer" className="quick-link">
                    <span className="quick-link-icon flex-shrink-0">
                      <i className="las la-comments"></i>
                    </span>
                  </Link>
                </li>

                <li className="quick-link-item d-none d-md-inline-flex">
                  <span className="quick-link-icon">
                    <i className="las la-user-circle"></i>
                  </span>

                  <span className="quick-link-content">
                    {_id ? (
                      <Link className="account-name">
                        {showprofile?.full_name || "My Account"}
                      </Link>
                    ) : (
                      <Link to="/login" className="login-link">
                        Register
                      </Link>
                    )}
                  </span>
                </li>

                <li className="quick-link-item d-none d-sm-flex">
                  <Link
                    to={_id ? "/Favratewishlist" : "/login"}
                    className="quick-link"
                  >
                    <span className="quick-link-icon flex-shrink-0">
                      <i className="lar la-heart"></i>
                    </span>
                  </Link>
                </li>

                <li className="quick-link-item">
                  <Link
                    to={
                      show_cart_list.length > 0
                        ? _id
                          ? "/cardlist"
                          : "/login"
                        : "/cardlist"
                    }
                    className="quick-link"
                  >
                    <span className="quick-link-icon flex-shrink-0">
                      <FaShoppingCart />
                    </span>
                  </Link>
                </li>

                <li className="quick-link-item d-lg-none">
                  <button
                    className="toggle-menu"
                    data-bs-toggle="modal"
                    data-bs-target="#exampleModal"
                  >
                    <i className="las la-bars"></i>
                  </button>
                </li>
              </ul>
            </div>
          </div>

          {/* ✅ MOBILE SEARCH BAR */}
          <div className="d-lg-none mt-2">
            <form onSubmit={(e) => e.preventDefault()}>
              <div className="input-group">
                <input
                  className="form-control"
                  type="text"
                  placeholder="Search gemstones..."
                  onClick={() => Navigate(`/search`)}
                  autoComplete="off"
                  style={{
                    borderRadius: "12px",
                    fontSize: "14px",
                    height: "42px",
                    boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  }}
                />
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Shearchbar;
